module.exports = __webpack_public_path__ + "img/image 25.dfa31427.png";